<template>
  <v-col
    cols="12"
    sm="8"
    md="4"
  >
    <div class="white--text text-center text-h5">
      <span class="the-digest">The Digest</span>
      <span class="font-weight-light"> of Human Rights Awards</span>
    </div>

    <div class="mx-2 mt-6">
      <form
        @submit.prevent="sendResetPasswordLink()"
        ref="form"
        lazy-validation
      >
        <v-text-field
          v-model="email"
          ref="email"
          label="Email"
          color="white"
          required
          dark
        ></v-text-field>

        <v-btn
          block
          depressed
          large
          :loading="loading"
          :disabled="loading"
          type="submit"
          class="mt-6 secondary primary--text"
          >Reset Password</v-btn>
      </form>
    </div>
  </v-col>
</template>

<script>
import messagesMixin from '@/mixins/messagesMixin'

export default {
  name: 'ForgotPassword',

  mixins: [messagesMixin],

  data () {
    return {
      email: '',
      loader: null,
      loading: false,
      messageSentSuccessfully: false
    }
  },

  mounted () {
    this.$nextTick(this.$refs.email.focus)
  },

  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]
      this.loader = null
    }
  },

  methods: {
    sendResetPasswordLink () {
      this.loader = 'loading'

      this.$store.dispatch('sendResetPasswordLink', {
        email: this.email
      })
        .then((data) => {
          this.loader = 'loading'
        })
        .catch(error => {
          console.log(error)

          this.loader = 'loading'
        })
    }
  }
}
</script>
